<template>
    <div class="avatar-letter d-flex justify-content-center align-items-center text-white bg-dark">
        <span>{{ initial }}</span>
    </div>
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        username: {
            type: String,
            default: '',
        }
    },
    computed: {
        initial() {
            return this.username ? this.username.trim().charAt(0).toUpperCase() : '?';
        }
    }
}
</script>

<style scoped>
.avatar-letter {
    aspect-ratio: 1 / 1;
    font-weight: bold;
}
</style>
